// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,import_extension=none"
// @generated from file chalk/common/v2/table.proto (package chalk.common.v2, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file chalk/common/v2/table.proto.
 */
export const file_chalk_common_v2_table: GenFile = /*@__PURE__*/
  fileDesc("ChtjaGFsay9jb21tb24vdjIvdGFibGUucHJvdG8SD2NoYWxrLmNvbW1vbi52MiI0CgVUYWJsZRIRCgdmZWF0aGVyGAEgASgMSAASDQoDdXJpGAIgASgJSABCCQoHcGF5bG9hZGIGcHJvdG8z");

/**
 * @generated from message chalk.common.v2.Table
 */
export type Table = Message<"chalk.common.v2.Table"> & {
  /**
   * @generated from oneof chalk.common.v2.Table.payload
   */
  payload: {
    /**
     * @generated from field: bytes feather = 1;
     */
    value: Uint8Array;
    case: "feather";
  } | {
    /**
     * @generated from field: string uri = 2;
     */
    value: string;
    case: "uri";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message chalk.common.v2.Table.
 * Use `create(TableSchema)` to create a new message.
 */
export const TableSchema: GenMessage<Table> = /*@__PURE__*/
  messageDesc(file_chalk_common_v2_table, 0);

